<template>
 <div>

     <Row :gutter="10" style="margin-bottom: 8px">
         <Col span="18">
             <RadioGroup v-model="city" type="button" size="small">
                 <Radio :label="cty" v-for="cty in cityArr">{{cty}}</Radio>
             </RadioGroup>
         </Col>
         <Col span="6">
             <Select v-model="startDate">
                 <Option :value="dt.value" v-for="dt in dateOptions">{{dt.title}}</Option>
             </Select>
         </Col>
     </Row>

     <Row>

         <Table :columns="headers" :data="orders" max-height="700" stripe
                :loading="$apollo.queries.orders.loading" size="small">
             <template slot-scope="{ row }" slot="lrName">
                 <span>{{row.orderDetails&&row.orderDetails.lrObject&&row.orderDetails.lrObject.hasOwnProperty('lrName')?row.orderDetails.lrObject.lrName:'-'}}</span>
             </template>
             <template slot-scope="{ row }" slot="pickupDate">
                 <span  style="font-size: 14px !important;">{{formatDate(row.pickupDate)}}</span>
             </template>
             <template slot-scope="{ row }" slot="orderNumber">
                 <span>{{row.orderNumber}}</span>
             </template>
             <template slot-scope="{ row }" slot="dealerName">
                        <span>{{row.clientobject.name}}<br>({{row.clientobject.address[0].city}})</span>
             </template>
             <template slot-scope="{ row }" slot="dealerMobile">
                 <span>{{row.clientobject.mobile}}</span>
             </template>

             <template slot-scope="{ row }" slot="newPickupParty">
                        <span v-if="row.orderDetails&&row.orderDetails.pickupPoint&&row.orderDetails.pickupPoint.pickupPartyId">
                            {{row.orderDetails.pickupPoint.pickupPartyName}}<br>({{row.orderDetails.pickupPoint.city}})</span>
                 <span v-else>-</span>
             </template>
             <template slot-scope="{ row }" slot="newPickupParty_Mobile">
                        <span v-if="row.orderDetails&&row.orderDetails.pickupPoint&&row.orderDetails.pickupPoint.pickupPartyId">
                            {{row.orderDetails.pickupPoint.mobile}}</span>
                 <span v-else>-</span>
             </template>
             <template slot-scope="{ row }" slot="ewayBillNumber">
                 <template v-if="row.orderDetails&&row.orderDetails.ewayBillNo">{{row.orderDetails.ewayBillNo}}</template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="isEwayVerified">
                 <template v-if="row.orderDetails&&row.orderDetails.isEwayBillVerified">{{row.orderDetails.isEwayBillVerified?'y':'n'}}</template>
                 <template v-else>-</template>
             </template>

             <template slot-scope="{ row }" slot="internalStatus">
                 <span style="text-transform: capitalize">{{row.internalStatus.name}}</span>
             </template>
             <template slot-scope="{ row }" slot="size">
                 <span style="text-transform: capitalize">{{row.materials.boxes}}</span>
             </template>
             <template slot-scope="{ row }" slot="weight">
                 <span style="text-transform: capitalize">{{row.materials.kg}}</span>
             </template>
             <template slot-scope="{ row }" slot="tempo_platNo">
                 <template v-if="row.orderDetails&&row.orderDetails.PIckupTempo">{{row.orderDetails.PIckupTempo.tempo.platNo}}</template>
                 <template v-else-if="row.orderDetails&&row.orderDetails.PickupTruck">{{row.orderDetails.PickupTruck.truck.platNo}}</template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="truck_platNo">
                 <template v-if="row.orderDetails&&row.orderDetails.truckOrder">{{row.orderDetails.truckOrder.truck.platNo}}</template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="truck_driverNumber">
                 <template v-if="row.orderDetails&&row.orderDetails.truckOrder">{{row.orderDetails.truckOrder.driverDetail.mobile}}</template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="truck_transporterName">
                 <template v-if="row.orderDetails&&row.orderDetails.truckOrder&&row.orderDetails.truckOrder.Transporter">
                     {{row.orderDetails.truckOrder.Transporter.name}}
                 </template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="truck_transporterNumber">
                 <template v-if="row.orderDetails&&row.orderDetails.truckOrder&&row.orderDetails.truckOrder.Transporter">
                     {{row.orderDetails.truckOrder.Transporter.mobile}}
                 </template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="truckOrder_Rate">
                 <template v-if="row.orderDetails&&row.orderDetails.truckOrder&&row.orderDetails.truckOrder.price">
                     {{row.orderDetails.truckOrder.price}}
                 </template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="truckOrder_lrCommission">
                 <template v-if="row.orderDetails&&row.orderDetails.truckOrder&&row.orderDetails.truckOrder.lrCommision">
                     {{row.orderDetails.truckOrder.lrCommision}}
                 </template>
                 <template v-else>-</template>
             </template>
             <template slot-scope="{ row }" slot="note">
                 <span style="text-transform: capitalize">{{row.note}}</span>
             </template>

         </Table>
     </Row>

 </div>
</template>

<script>
import {FILTER_ORDERS_CITYWISE} from '../graphql/queries/Orders'
import {SUBSCRIBE_ORDERS_CITYWISE} from '../graphql/subscription/Orders'
import moment from 'moment'

    export default {
        name: "CityWiseOrdersSheet",
        apollo: {
            orders: {
                query: FILTER_ORDERS_CITYWISE,
                subscribeToMore: {
                    document: SUBSCRIBE_ORDERS_CITYWISE,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate:  moment(this.startDate).add(1, 'day').format('YYYY-MM-DD'),
                            city: this.cityObj
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.orders = subscriptionData.data.orders;
                    },
                },
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: moment(this.startDate).add(1, 'day').format('YYYY-MM-DD'),
                        city: this.cityObj
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.orders = data.orders;
                    }
                }
            }
        },
        data:function () {
            return{
                orders: [],
                city: 'Ahmedabad',
                cityArr: ['Ahmedabad', 'Baroda', 'Surat','mumbai','pune','Bangalore', 'Hyderabad'],
                startDate: moment().format('YYYY-MM-DD'),
                dateOptions:[
                    {title: 'Today', value: moment().format('YYYY-MM-DD')},
                    {title: 'Yesterday', value: moment().subtract(1, 'day').format('YYYY-MM-DD')},
                    {title: moment().subtract(2, 'days').format('ddd, MMM D, YYYY'), value: moment().subtract(2, 'days').format('YYYY-MM-DD')},
                    {title: moment().subtract(3, 'days').format('ddd, MMM D, YYYY'), value: moment().subtract(3, 'days').format('YYYY-MM-DD')},
                    {title: moment().subtract(4, 'days').format('ddd, MMM D, YYYY'), value: moment().subtract(4, 'days').format('YYYY-MM-DD')},
                    {title: moment().subtract(5, 'days').format('ddd, MMM D, YYYY'), value: moment().subtract(5, 'days').format('YYYY-MM-DD')},
                    {title: moment().subtract(6, 'days').format('ddd, MMM D, YYYY'), value: moment().subtract(6, 'days').format('YYYY-MM-DD')},
                    ],
                date:  moment().format('YYYY-MM-DD'),
                headers: [
                    {title: 'Pickup Date', slot: 'pickupDate', width:107,
                        renderHeader: function (h) {return h('div', [h('p', 'Pickup')])}},
                    {title: 'ERP Order No', slot: 'orderNumber', width:160, className: "table-orderNum-column"},
                    {title: 'LR No.', slot: 'lrName',width:75, className: "table-orderNum-column"},
                    {title: 'Software Order Status', slot: 'internalStatus', width:122, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Software'), h('p', 'Order Status')])}},
                    {title: 'Party Name', slot: 'dealerName', width:200, className: "table-dealer-column"},
                    {title: 'Party Number', slot: 'dealerMobile',width:117, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Party'), h('p', 'Number')])}},
                    {title: 'Loading Pt', slot: 'newPickupParty',width:150, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Loading'), h('p', 'Pt')])}},
                    {title: 'Company No.', slot: 'newPickupParty_Mobile',width:117, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Company'), h('p', 'Number')])}},
                    {title: 'Eway Bill No.', slot: 'ewayBillNumber',width:132, className: "table-orderNum-column"},
                    {title: 'Bills', slot: 'isEwayVerified',width:62, className: "table-orderNum-column"},
                    {title: 'Remark', slot: 'note',width:250, className: "table-orderNum-column"},
                    {title: 'Order Details', slot: 'size',width:164, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Order Details'), h('p', '(Size & Qty)')])}},
                    {title: 'Total Wt.', slot: 'weight',width:80, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Total'), h('p', 'Weight')])}},
                    {title: 'Tempo No.', slot: 'tempo_platNo', width:136,className: "table-orderNum-column"},

                    {title: 'Truck No.', slot: 'truck_platNo', width:136,className: "table-orderNum-column"},
                    {title: 'Truck Driver No', slot: 'truck_driverNumber',width:120, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Truck Driver'), h('p', 'No')])}},
                    {title: 'Transporter Name', slot: 'truck_transporterName',width:120, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Transporter'), h('p', 'Name')])}},
                    {title: 'Transporter Number', slot: 'truck_transporterNumber',width:120, className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Transporter'), h('p', 'Number')])}},
                    {title: 'Truck Rate', slot: 'truckOrder_Rate',width:108, className: "table-orderNum-column"},
                    {title: 'LR comm.', slot: 'truckOrder_lrCommission',width:108, className: "table-orderNum-column"}
                ],
            }
        },
        computed:{
          cityObj: function(){
              return {"address":[{"city": this.city}]}
          }
        },
        methods:{
            formatDate(date){
                return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            },
        }
    }
</script>

<style scoped>
    /deep/ .ivu-table-wrapper, .ivu-table, .ivu-table-body {
        cursor: pointer !important;
    }
    /deep/ .ivu-table td.table-orderNum-column{
        font-size: 14px;
    }
    /deep/ .ivu-table td.table-dealer-column{
        font-size: 14px;
    }
    /deep/ .ivu-table td.table-dealer-column div.ivu-table-cell:hover{
        background: white;
    }
  /deep/.ivu-table-cell{
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
</style>
